interface ListProps {
  handleClick?: React.MouseEventHandler<HTMLDivElement>;
  handleKeyDown?: React.KeyboardEventHandler<HTMLDivElement>;
  header?: string | null;
  items: ListItemProps[];
}
interface ListItemProps {
  chips?: string[] | null; // Chips are used to show applied filters or multiple selected items. (https://dev-design.realpage.com/raul/components/list#list-group-with-chips)
  id: string;
  subtitle?: string | null;
  title: string | null;
}

const List = ({ handleClick, handleKeyDown, items }: ListProps) => {
  const ListItem = ({ chips, id, subtitle, title }: ListItemProps) => {
    return (
      <div
        className={handleClick && 'r-cursor-pointer'}
        id={id}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        role="button"
        tabIndex={0}
        title={title || ''}
      >
        <raul-list-item
          // @ts-expect-error: children and slot "does not exist on type"
          // eslint-disable-next-line react/no-children-prop
          children={
            <>
              {title && (
                <raul-list-item-title
                  // @ts-expect-error: dangerouslySetInnerHTML "does not exist on type"
                  dangerouslySetInnerHTML={{ __html: title }}
                />
              )}
              {subtitle && (
                <raul-list-item-subtitle
                  // @ts-expect-error: dangerouslySetInnerHTML "does not exist on type"
                  dangerouslySetInnerHTML={{ __html: subtitle }}
                />
              )}
              {chips?.length && (
                <div className="r-mt-2">
                  {chips.map((chip) => (
                    <raul-chip
                      // @ts-expect-error: children and slot "does not exist on type"
                      // eslint-disable-next-line react/no-children-prop
                      children={chip}
                      key={chip}
                      class="r-mr-2"
                    />
                  ))}
                </div>
              )}
            </>
          }
        />
      </div>
    );
  };

  return (
    <raul-list>
      {items.map(({ chips, id, subtitle, title }) => (
        <ListItem
          key={id}
          chips={chips}
          id={id}
          subtitle={subtitle}
          title={title}
        />
      ))}
    </raul-list>
  );
};

export default List;
